import { useIdentify } from '@hungryroot/customer';
import { Information } from '@hungryroot/icons';
import { Price } from '@hungryroot/pho';
import { Heading, Text } from '@hungryroot/ramen';
import { useProductSubscriptionCancelWarningExperimentApi } from '@hungryroot/supplements';
import styles from './CreditMessage.module.css';

interface Props {
  testid?: string;
  className?: string;
}

function getWalletDetail(
  accountBalance: number | undefined,
  rolloverCredits: number | undefined
) {
  if (accountBalance && rolloverCredits) {
    return (
      <Text>
        <span>
          Remaining wallet balance (<Price amount={accountBalance} /> +{' '}
          {rolloverCredits} credits)
        </span>
      </Text>
    );
  }
  if (!accountBalance && rolloverCredits) {
    return (
      <Text>
        <span>Remaining wallet balance ({rolloverCredits} credits)</span>
      </Text>
    );
  }
  if (accountBalance && !rolloverCredits) {
    return (
      <Text>
        <span>
          Remaining wallet balance (<Price amount={accountBalance} />)
        </span>
      </Text>
    );
  }
  return;
}

export function CreditMessage(props: Props) {
  const { testid, className } = props;

  const { customerData } = useIdentify();
  const { rollover_credits: rolloverCredits, credit: accountBalance } =
    customerData || {};
  const validAccountBalance =
    accountBalance && parseFloat(accountBalance) > 0
      ? parseFloat(accountBalance)
      : undefined;
  const validRolloverCredits =
    rolloverCredits && rolloverCredits > 0 ? rolloverCredits : undefined;

  const subscriptionWarningText =
    useProductSubscriptionCancelWarningExperimentApi();

  if (
    validAccountBalance !== undefined ||
    validRolloverCredits !== undefined ||
    subscriptionWarningText !== undefined
  ) {
    return (
      <div data-testid={testid} className={`${styles.container} ${className}`}>
        <Heading variant="H6" className={styles.title}>
          If you cancel your plan, you'll lose these perks:
        </Heading>
        {subscriptionWarningText}
        {validAccountBalance || validRolloverCredits ? (
          <div data-testid={`${testid}-wallet`} className={styles.text}>
            <Information />
            {getWalletDetail(validAccountBalance, validRolloverCredits)}
          </div>
        ) : null}
      </div>
    );
  }
  return null;
}
